module.exports = __webpack_public_path__ + "img/Embers-Adrift-2022-014.97a1eca9.jpg";